{
	"page": {
		"title": "Venues",
		"intro": "Where competition happens. A <strong>venue</strong> may hold <strong>courts, mats or pools</strong> of its own — one level deep. Meets are scheduled at a venue or at one of its courts.",
		"addVenue": "Add venue",
		"building": "This page is being built.",
		"count_one": "{{n}} venue",
		"count_other": "{{n}} venues",
		"addCourt": "Add court in {{name}}"
	},
	"filters": {
		"levelLabel": "Show",
		"allVenues": "All venues and courts",
		"topLevelOnly": "Top-level venues only",
		"searchPlaceholder": "Search venues by code or name",
		"insideLabel": "Courts inside",
		"searchVenues": "Search venues"
	},
	"table": {
		"code": "Code",
		"name": "Name",
		"city": "City",
		"parent": "Inside",
		"parentTitle": "The venue this court or area sits in",
		"children": "Courts / areas",
		"childrenTitle": "View the courts and areas inside this venue",
		"meets": "Meets",
		"meetsTitle": "Meets scheduled at this venue itself, not at its courts",
		"created": "Created",
		"updated": "Updated",
		"viewChildrenLabel": "View courts of {{name}}",
		"addChildLabel": "Add a court or area in {{name}}",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} venue",
		"summary_other": "{{from}}–{{to}} of {{total}} venues",
		"empty": "No venues"
	},
	"empty": {
		"filteredTitle": "No venues match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No venues yet",
		"noneDescription": "Add the venues competition takes place in.",
		"childrenNoneTitle": "No courts or areas yet",
		"childrenNoneDescription": "Add the courts, mats or pools inside {{name}}.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add venue",
		"addChildTitle": "Add a court or area in {{name}}",
		"addDescription": "A place where meets are scheduled — a venue in its own right, or a court, mat or pool inside one.",
		"addSubmit": "Add venue",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} meet is scheduled here — a change shows on its schedule immediately.",
		"editInUse_other": "{{count}} meets are scheduled here — a change shows on their schedules immediately.",
		"editEmpty": "No meets are scheduled here yet.",
		"section": {
			"identity": "Identity",
			"identityHint": "How the venue reads on schedules and start lists.",
			"location": "Location",
			"locationHint": "Where it is, and whether it sits inside another venue."
		},
		"field": {
			"name": "Name",
			"code": "Code",
			"codeHint": "Letters, numbers, - and _ only, like AQC or BDH-C1. Stored in capitals.",
			"city": "City",
			"cityHint": "Leave empty for a court or area — it is where its venue is.",
			"parent": "Inside venue",
			"parentHint": "Leave empty for a venue in its own right. Venues nest one level only.",
			"parentNone": "None — a venue in its own right",
			"parentLocked": "This venue has courts or areas of its own, so it cannot be placed inside another."
		},
		"placeholder": {
			"name": "Aquatics Centre",
			"code": "AQC",
			"city": "Kuala Lumpur"
		}
	},
	"delete": {
		"title": "Delete venue",
		"description": "Delete <strong>{{name}}</strong>? This only works while nothing hangs off it — courts or areas inside it, or meets scheduled at it.",
		"confirm": "Delete venue",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete venue"
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add venue",
		"updateFailed": "Couldn't update venue"
	},
	"errors": {
		"codeTaken": "A venue with that code already exists.",
		"parentRefused": "That venue can't hold this one: venues nest one level only, and a venue with courts of its own can't be placed inside another.",
		"inUse": "This venue still has courts or areas, or meets scheduled at it.",
		"invalidValue": "Invalid value"
	},
	"sort": {
		"cityAsc": "City A–Z",
		"cityDesc": "City Z–A"
	},
	"stats": {
		"total": "Listed",
		"matching": "matching the search",
		"view": {
			"top": "top-level venues",
			"all": "venues and courts",
			"inside": "courts in this venue"
		},
		"venues": "Venues",
		"courts": "Courts, mats & pools",
		"withCourts": "Venues with courts"
	}
}
